module.exports = __webpack_public_path__ + "static/IL-5ce5400e5845dd298397f3d7592634eb.svg";